import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import {
  SearchFilter,
  CalendarFilter2,
} from "../../../Components/Search/Search";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { GetGlobalData } from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import {
  useGetAllAccountsQuery,
  useGetCompanyFundsQuery,
} from "../../../../api";
import { format } from "date-fns";

function Cashbook() {
  const { CashBook: data, GlobalData } = useSelector(
    (state) => state.companyFund
  );
  console.log("data", data);
  const [search, setSearch] = useState("");
  const [account, setAccount] = useState(null);
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  let start =
    startDate === undefined ? "" : format(new Date(startDate), "DD/MM/YYYY");
  let end =
    endDate === undefined ? "" : format(new Date(endDate), "DD/MM/YYYY");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: companyFunds, refetch } = useGetCompanyFundsQuery({
    pageNumber,
    pageSize,
    search,
    endDate: end ? end : "",
    startDate: start ? start : "",
    accountNumber: account ? account : "",
  });

  const { data: banks } = useGetAllAccountsQuery({
    Search: "bank",
    // ApprovalStatus: 0,
    PageSize: 10000,
    PageNumber: 1,
  });

  console.log({ companyFunds, banks });

  useEffect(() => {
    dispatch(GetGlobalData()).then((response) => {
      if (response?.payload?.Banks?.length > 0) {
        setAccount(response.payload.Banks[0]);
      }
    });
    refetch();
  }, [account]);

  const actionButton = (
    <>
      <CTAButtons
        onClick={() => {
          navigate("../UploadBankStatement");
        }}
      >
        Upload Bank Statement
      </CTAButtons>
    </>
  );

  const preTableDiv = (
    <div
      className={`h-max py-4 pl-4 bg-white rounded-xl flex-1 flex-col items-start`}
    >
      <p>Balance BF</p>
      <h2 className="text-[36px]">
        {FormatCurrency(companyFunds?.responseObject?.pageItems[0]?.closingBal)}
      </h2>
    </div>
  );

  let mockData = companyFunds?.responseObject?.pageItems[0]?.cashBooks
    ?.filter((i) =>
      i.ftLedger?.accountName.toLowerCase().includes(search.toLowerCase())
    )
    .map((item) => {
      // console.log({ item: item });
      return {
        date: FormatDateTime(item?.createdDate),
        value_date: FormatDateTime(item?.valueDate),
        description: item?.description,
        account_name: item?.ftLedger?.accountName,
        account_number: item?.ftLedger?.accountNumber,
        credit: FormatCurrency(item?.credit),
        debit: FormatCurrency(item?.debit),
        balance: FormatCurrency(item.ftLedger?.closingBal),
      };
    });

  let currentHeaders = [
    {
      title: "Date",
      key: "date",
    },
    {
      title: "Value Date",
      key: "value_date",
    },
    {
      title: "Description",
      key: "description",
    },
    {
      title: "Account Name",
      key: "account_name",
    },
    {
      title: "Account Number",
      key: "account_number",
    },
    {
      title: "Credit",
      key: "credit",
    },
    {
      title: "Debit",
      key: "debit",
    },
    {
      title: "Balance",
      key: "balance",
    },
  ];

  function filterByBank(bankName) {
    setAccount(bankName);
  }

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  return (
    <RouteLayout title={"Finance"}>
      <PageStyle
        title={"Cashbook"}
        hasBack={false}
        action={[actionButton]}
        isMain={true}
        preChildren={preTableDiv}
      >
        <div className="flex justify-between items-center flex-wrap mb-4">
          <div className={`${DashboardStyle.dashboard_filter} min-w-[60%]`}>
            <SearchFilter
              text={(value) => setSearch(value)}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />

            <CalendarFilter2
              name="Select Date Range"
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />

            <div className="text-green-800">
              <p>Account</p>
              <select
                value={account?.accountName}
                onChange={({ target }) => filterByBank(target.value)}
                defaultValue={""}
                className="rounded-lg border border-[#D9E9DA] h-[40px] bg-green-50 bg-opacity-10 max-w-[240px] focus:outline-green-800"
              >
                <option value={""}>Select Account</option>
                {banks?.result?.map((b) => (
                  <option value={b.accountNumber}>{b.accountName}</option>
                ))}
              </select>
            </div>

            {/* <div className="min-h-full border-solid border-4 border-transparent">
              <FilterButton onSubmit={()=> {}} onClick={() => setFilterModal(prev=> !prev)} name="" />
            </div> */}
          </div>
          {/* <form className={DashboardStyle.dashboard_filter}>
            <SearchFilter
              value={searchText}
              text={(searchText) => setSearchText(searchText)}
            />
            <ProDropFilter
              filter={filter}
              setFilter={setFilter}
              name={"Status"}
              filterBy={filterBy}
            />
            <CalendarFilter
              date={(date) => setDate(date)}
              name="Select Date Range"
              startDate={date?.from}
              endDate={date?.to}
            />
            <FilterButton onClick={() => findSearch()} name="" />
          </form> */}
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                {currentHeaders.map((header, i) => (
                  <th
                    className={`!text-[#29382A] ${
                      header.title === "Actions" && "flex justify-end !pr-6"
                    } ${header.title === "Status" && "!text-center"}`}
                    key={i}
                  >
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={mockData}
                keys={currentHeaders.map((header) => header.key)}
                rowOptions={null}
              />
            </tbody>
          </Table>
        </div>

        {/* <Pagination
          last_page={data?.totalNumberOfPages}
          present_page={data?.currentPage || pageNumber}
          totalRows={
            data?.pageItems?.length < pageSize && pageNumber === 1
              ? data.pageItems.length
              : data?.totalRows || 0
          }
          pageSize={
            data?.pageItems?.length < pageSize
              ? data.pageItems.length
              : data?.pageSize || 0
          }
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        /> */}

        <Pagination
          last_page={
            companyFunds?.responseObject?.totalNumberOfPages / pageSize
          }
          present_page={companyFunds?.responseObject?.currentPage}
          totalRows={companyFunds?.responseObject?.totalNumberOfPages}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        />
      </PageStyle>
    </RouteLayout>
  );
}

export default Cashbook;

function RequestTable({
  data,
  keys,
  selectable,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {
  return (
    <>
      {data?.map((item) => (
        <tr key={item.id}>
          {selectable && (
            <td>
              <input
                type="checkbox"
                checked={selectedItems.includes(item.id)}
                onChange={(e) => HandleSelectedItems(item.id, e.target.checked)}
                style={{ height: "20px", width: "20px" }}
              />
            </td>
          )}
          {keys
            .filter((key) => key)
            .map((key, i) =>
              key === "status" ? (
                <td key={i}>
                  <StatusText status={item.status} />
                </td>
              ) : (
                <td key={i}>
                  {key === "date" && item.date}
                  {key === "value_date" && item.value_date}
                  {key === "description" && item.description}
                  {key === "account_name" && item.account_name}
                  {key === "account_number" && item.account_number}
                  {key === "credit" && item.credit}
                  {key === "debit" && item.debit}
                  {key === "balance" && item.balance}
                </td>
              )
            )}
        </tr>
      ))}
    </>
  );
}

function StatusText({ status }) {
  return (
    <td style={{ textAlign: "center" }}>
      <span
        className={`
          ${
            status === "Paid"
              ? "bg-green-100 text-green-700"
              : status === "Unpaid"
              ? "bg-red-100 text-red-700"
              : "text-gray-700"
          }
        `}
        style={{
          textAlign: "center",
          padding: "0.3rem 0.4rem",
          borderRadius: "10px",
          fontSize: "0.875rem",
          fontWeight: "600",
        }}
      >
        {status}
      </span>
    </td>
  );
}
